module.exports = __webpack_public_path__ + "img/store-play.582bfdd3.png";